import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import { I18n } from "react-redux-i18n";

// Replace with your Wolt OAuth config
const WOLT_CLIENT_ID = "3c252646-5908-4c39-905f-e9f83c349551";
const WOLT_CLIENT_ID_TEST = "bdcb43f7-386d-4978-bf70-772f35c65fe3";
//const WOLT_REDIRECT_URI = "https://restaurant.eatwithme.online:8444/demo/eatwithme.server/integration/wolt/oauth";
const WOLT_REDIRECT_URI = "https://instance.eatwithme.online/eatwithme.server/integration/wolt/oauth";
//const WOLT_REDIRECT_URI = "https://console.eatwithme.online/#/adminMenu/wolt";
export default function WoltOAuth({ instanceId, test }) {
  const [authCode, setAuthCode] = useState(null);
  const [error, setError] = useState(null);

  // Step 1: Redirect to Wolt OAuth
  const authUrl = test
    ? "https://developer.development.dev.woltapi.com/integrate"
    : "	https://developer.wolt.com/integrate";
  const startOAuth = () => {
    const url = `${authUrl}?client_id=${encodeURIComponent(test ? WOLT_CLIENT_ID_TEST : WOLT_CLIENT_ID)}&redirect_url=${encodeURIComponent(WOLT_REDIRECT_URI)}&state=${localStorage.instance + "-" + instanceId + "-" + new Date().getTime()}`;
    window.open(url, "_new");
  };

  // Step 2: Handle callback (should be in a separate route/component)
  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");
    if (code && state === instanceId) {
      setAuthCode(code);
      // Here you would send the code to your backend to exchange for a token
    }
    if (params.get("error")) {
      setError(params.get("error"));
    }
  }, [instanceId]);

  return (
    <div>
      <h3>{I18n.t("admin_local.connect_wolt_instance")}</h3>
      {authCode ? (
        <div>
          <p>{I18n.t("admin_local.authorization_code_received")}</p>
          <code>{authCode}</code>
        </div>
      ) : (
        <Button variant="contained" color="primary" onClick={startOAuth}>{I18n.t("admin_local.connect_button")}</Button>
      )}
      {error && <div style={{ color: "red" }}>Error: {error}</div>}
    </div>
  );
}
